import React, { useState, useEffect, useRef } from "react";
import { fetchMathProblem } from "../services/api";

interface MathProblemGameProps {
  selectedCountry: string;
  difficulty: "easy" | "normal";
}

const MathProblemGame: React.FC<MathProblemGameProps> = ({ selectedCountry, difficulty }) => {
  const [answer, setAnswer] = useState("");
  const [spokenUrl, setSpokenUrl] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [message, setMessage] = useState("");
  const [correctCount, setCorrectCount] = useState(0);
  const [nextData, setNextData] = useState<{ answer: string, spokenurl: string } | null>(null);
  const [readyForNext, setReadyForNext] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const loadNumber = async () => {
    const data = await fetchMathProblem(0, 10, selectedCountry, difficulty);
    setAnswer(data.answer);
    setSpokenUrl(data.spokenurl);
  };

  // Prefetch the next question in the background
  const prefetchNext = async () => {
    const next = await fetchMathProblem(0, 10, selectedCountry, difficulty);
    setNextData(next);
  };

  // Initialize by loading the first question and prefetching the next one
  useEffect(() => {
    console.log("first useEffect");
    loadNumber();
    setTimeout(() => {
      prefetchNext(); // Prefetch the next question after 1s
    }, 1000);    
    
  }, [selectedCountry, difficulty]);

  // Update current question only when `readyForNext` is true and `nextData` is available
  useEffect(() => {
    if (readyForNext && nextData) {
      setAnswer(nextData.answer);
      setSpokenUrl(nextData.spokenurl);
      setNextData(null); // Clear nextData after setting it as the current question
      setReadyForNext(false); // Reset readiness for future correct answers
      prefetchNext(); // Start prefetching the following question
    }
  }, [nextData, readyForNext]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (inputValue == answer) {
      setMessage("Correct");
      setCorrectCount((prev) => prev + 1);
      setInputValue("");

      setTimeout(() => {
        setMessage("");
        setReadyForNext(true);
      }, 1000);
    } else {
      setMessage("Incorrect");
    }
  };

  useEffect(() => {
    if (spokenUrl && audioRef.current) {
      audioRef.current.load();
      audioRef.current.play();
    }
  }, [spokenUrl]);

  return (
    <div>
      <h2>Math Quiz ({difficulty})</h2>
      <p>Correct answers: {correctCount}</p>

      {spokenUrl && (
        <div>
        <audio ref={audioRef} controls>
          <source src={spokenUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
        <form onSubmit={handleSubmit}>
          <input 
            type="number" 
            value={inputValue} 
            onChange={(e) => setInputValue(e.target.value)} 
            required
          />
          <button type="submit">Submit</button>
        </form>
      </div>
      )}
      {message && <p>{message}</p>}
    </div>
  );
};

export default MathProblemGame;
